import { useEffect, useRef } from "react";

// Invisible marker dropped at the bottom of a scrollable list — fires
// `onVisible` once it scrolls into view of `root` (the scroll container;
// null defaults to the browser viewport). One IntersectionObserver per
// mount rather than a scroll-position calculation on every scroll event.
export function LoadMoreSentinel({ onVisible, disabled, root = null, testId }) {
  const ref = useRef(null);
  const onVisibleRef = useRef(onVisible);
  onVisibleRef.current = onVisible;

  useEffect(() => {
    if (disabled || !ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0]?.isIntersecting) onVisibleRef.current?.(); },
      { root, rootMargin: "200px" }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [disabled, root]);

  return <div ref={ref} data-testid={testId} className="h-px w-full" aria-hidden />;
}
